import React from 'react';

const Pos: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M31.6667 5H33.0001C34.1046 5 35.0001 5.89543 35.0001 7V33C35.0001 34.1046 34.1046 35 33.0001 35H31.6667V5Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 7.66666C9 6.56209 9.89543 5.66666 11 5.66666H25.6667C26.7712 5.66666 27.6667 6.56209 27.6667 7.66666V17.3333C27.6667 18.4379 26.7712 19.3333 25.6667 19.3333H11C9.89543 19.3333 9 18.4379 9 17.3333V7.66666ZM25.6667 7.66666L11 7.66666V17.3333H25.6667V7.66666Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.83325 23.3333C9.83325 22.781 10.281 22.3333 10.8333 22.3333H12.4999C13.0522 22.3333 13.4999 22.781 13.4999 23.3333C13.4999 23.8856 13.0522 24.3333 12.4999 24.3333H10.8333C10.281 24.3333 9.83325 23.8856 9.83325 23.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 23.3333C16.5 22.781 16.9477 22.3333 17.5 22.3333H19.1667C19.719 22.3333 20.1667 22.781 20.1667 23.3333C20.1667 23.8856 19.719 24.3333 19.1667 24.3333H17.5C16.9477 24.3333 16.5 23.8856 16.5 23.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.83325 28.3333C9.83325 27.781 10.281 27.3333 10.8333 27.3333H12.4999C13.0522 27.3333 13.4999 27.781 13.4999 28.3333C13.4999 28.8856 13.0522 29.3333 12.4999 29.3333H10.8333C10.281 29.3333 9.83325 28.8856 9.83325 28.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.83325 33.3333C9.83325 32.781 10.281 32.3333 10.8333 32.3333H12.4999C13.0522 32.3333 13.4999 32.781 13.4999 33.3333C13.4999 33.8856 13.0522 34.3333 12.4999 34.3333H10.8333C10.281 34.3333 9.83325 33.8856 9.83325 33.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 28.3333C16.5 27.781 16.9477 27.3333 17.5 27.3333H19.1667C19.719 27.3333 20.1667 27.781 20.1667 28.3333C20.1667 28.8856 19.719 29.3333 19.1667 29.3333H17.5C16.9477 29.3333 16.5 28.8856 16.5 28.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 33.3333C16.5 32.781 16.9477 32.3333 17.5 32.3333H19.1667C19.719 32.3333 20.1667 32.781 20.1667 33.3333C20.1667 33.8856 19.719 34.3333 19.1667 34.3333H17.5C16.9477 34.3333 16.5 33.8856 16.5 33.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1667 23.3333C23.1667 22.781 23.6145 22.3333 24.1667 22.3333H25.8334C26.3857 22.3333 26.8334 22.781 26.8334 23.3333C26.8334 23.8856 26.3857 24.3333 25.8334 24.3333H24.1667C23.6145 24.3333 23.1667 23.8856 23.1667 23.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1667 28.3333C23.1667 27.781 23.6145 27.3333 24.1667 27.3333H25.8334C26.3857 27.3333 26.8334 27.781 26.8334 28.3333C26.8334 28.8856 26.3857 29.3333 25.8334 29.3333H24.1667C23.6145 29.3333 23.1667 28.8856 23.1667 28.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1667 33.3333C23.1667 32.781 23.6145 32.3333 24.1667 32.3333H25.8334C26.3857 32.3333 26.8334 32.781 26.8334 33.3333C26.8334 33.8856 26.3857 34.3333 25.8334 34.3333H24.1667C23.6145 34.3333 23.1667 33.8856 23.1667 33.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64461 2.88188C4.89899 1.50774 6.10765 0.666656 7.39 0.666656H29.2766C30.559 0.666656 31.7676 1.50771 32.022 2.88183C32.3104 4.43969 32.6667 7.25639 32.6667 11.6667C32.6667 17.4989 32.0407 31.4155 31.8035 36.4807C31.7285 38.0827 30.4073 39.3333 28.8096 39.3333H7.85706C6.2593 39.3333 4.93809 38.0827 4.86309 36.4807C4.62596 31.4155 4 17.4989 4 11.6667C4 7.25642 4.35622 4.43975 4.64461 2.88188ZM7.39 2.66666C6.95438 2.66666 6.66953 2.9308 6.61119 3.24593C6.34762 4.66975 6 7.36346 6 11.6667C6 17.4405 6.62275 31.3002 6.8609 36.3872C6.88567 36.9161 7.32152 37.3333 7.85706 37.3333H28.8096C29.3451 37.3333 29.7809 36.9161 29.8057 36.3872C30.0439 31.3002 30.6667 17.4405 30.6667 11.6667C30.6667 7.36343 30.319 4.66972 30.0554 3.24591C29.9971 2.93079 29.7122 2.66666 29.2766 2.66666H7.39Z"
      />
    </svg>
  );
};

export default Pos;
